import {useCallback, useEffect, useState} from "react";
import {fetchPendingOrders} from "../infrastructure/pendingOrderApi";
import {getOrElse, initial, isSuccess, pending} from "../../common/domain/RemoteData.model";
import {useComercialContext} from "../../comercial/ComercialContext";

/**
 * Hook con los pedidos pendientes del cliente (o del cliente suplantado en
 * modo comercial), ya agrupados por producto por el backend.
 *
 * El reparto entre "ya hay stock" (restocked) y "en espera" (waiting) sale del
 * flag isRestocked que calcula el backend: no se recalcula aquí.
 */
export const usePendingOrders = () => {
    const [pendingData, setPendingData] = useState(initial([]));
    const {actingAsCliente} = useComercialContext();

    const refresh = useCallback(async () => {
        setPendingData(pending());
        const result = await fetchPendingOrders(actingAsCliente?.numCliente ?? null);
        setPendingData(result);
    }, [actingAsCliente?.numCliente]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const removeLocally = useCallback((productCode) => {
        setPendingData((current) => {
            if (!isSuccess(current)) {
                return current;
            }
            return {...current, value: current.value.filter((it) => it.product.code !== productCode)};
        });
    }, []);

    const allPending = getOrElse(pendingData, []) ?? [];
    const restocked = allPending.filter((it) => it.isRestocked);
    const waiting = allPending.filter((it) => !it.isRestocked);

    return {pendingData, allPending, restocked, waiting, refresh, removeLocally};
};
